import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column border-top",
  id: "kt_footer"
}
const _hoisted_2 = { class: "text-dark order-2 order-md-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold me-1" }, "2022©", -1)
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("a", {
          href: _ctx.web_fedup,
          target: "_blank",
          class: "text-gray-800 text-hover-primary"
        }, [
          (_ctx.asideTheme === 'dark')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.brandDarkLogo,
                alt: _ctx.appName,
                class: "h-30px"
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.asideTheme === 'light')
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.brandLightLogo,
                alt: _ctx.appName,
                class: "h-30px"
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ], 8, _hoisted_4),
        _createTextVNode(),
        _createElementVNode("span", _hoisted_7, " - versión " + _toDisplayString(_ctx.version), 1)
      ])
    ], 2)
  ]))
}